var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "detailBox"
  }, [_c('div', {
    staticClass: "detail"
  }, _vm._l(_vm.detailArray, function (value, key) {
    return _c('div', {
      key: key,
      staticClass: "detailLi"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.returnDetailName(key)) + ":")]), _c('span', {
      staticClass: "info"
    }, [_vm._v(_vm._s(value))])]);
  }), 0), _c('div', {
    staticClass: "videoInput"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('common.videoInput')))]), _c('el-radio-group', {
    staticClass: "radioBox",
    on: {
      "input": _vm.dealDefaultValue
    },
    model: {
      value: _vm.selectVideoInput,
      callback: function ($$v) {
        _vm.selectVideoInput = $$v;
      },
      expression: "selectVideoInput"
    }
  }, _vm._l(_vm.videoInputArray, function (item) {
    return _c('el-radio', {
      key: item,
      staticClass: "radioBox showLabel",
      attrs: {
        "label": item,
        "disabled": item != _vm.selectVideoInput
      }
    }, [_vm._v(" " + _vm._s(_vm.returnLabel(item)) + " ")]);
  }), 1)], 1), _c('div', {
    staticClass: "audioInput"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('common.audioInput')))]), _c('el-radio-group', {
    staticClass: "radioBox",
    model: {
      value: _vm.selectAudioInput,
      callback: function ($$v) {
        _vm.selectAudioInput = $$v;
      },
      expression: "selectAudioInput"
    }
  }, [_vm._l(_vm.audioInputChannel[_vm.selectVideoInput], function (item) {
    return _c('el-radio', {
      key: item,
      staticClass: "radioBox showLabel",
      attrs: {
        "label": item,
        "disabled": item != _vm.selectAudioInput
      }
    }, [_vm._v(" " + _vm._s(_vm.returnAudioInput(item)) + " ")]);
  }), _c('el-radio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.deviceType === 'pack' || _vm.deviceType === 'receiver',
      expression: "deviceType === 'pack' || deviceType === 'receiver'"
    }],
    key: "voip",
    staticClass: "radioBox showLabel oneLine",
    attrs: {
      "label": "voip",
      "disabled": _vm.selectVideoInput != 'noVideo'
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('addTvuOne.voip')) + " "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.$t(`addTvuOne.${_vm.voipTipsMap[_vm.deviceType]}`),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-help2"
  })])], 1), _c('el-radio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.deviceType === 'pack' || _vm.deviceType === 'receiver',
      expression: "deviceType === 'pack' || deviceType === 'receiver'"
    }],
    key: "noAudio",
    staticClass: "radioBox showLabel oneLine",
    attrs: {
      "label": "noAudio",
      "disabled": true
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('addTvuOne.noAudio')) + " ")])], 2)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };